// Copie de apps/cinepass/packages/frontend/src/app/use-debounced.ts (meme template) : deux apps ne partagent pas de code.
import { useEffect, useState } from "react";

/**
 * `value` apres `delay` ms sans changement. Chaque changement relance l'attente : seule la derniere
 * valeur passe, jamais une valeur du milieu. Au premier rendu la valeur est rendue telle quelle.
 *
 * L apercu de la date floue s en sert pour ne demander qu une fois la frappe terminee.
 */
export function useDebounced<T>(value: T, delay: number): T {
  const [debounced, setDebounced] = useState(value);

  useEffect(() => {
    const timer = setTimeout(() => setDebounced(value), delay);
    return () => clearTimeout(timer);
  }, [value, delay]);

  return debounced;
}
